import { useTranslation } from 'react-i18next';
import CustomCard from '../../cards/CustomCard';
import { SearchCategoryResult as SearchCategoryResultType } from '../../../redux/store/api/api';
import Loader from '../../loader/Loader';
import SearchCategoryResult from '../SearchCategoryResult';

interface SearchCategoryCardProps {
  isLoading: boolean;
  searchResult: SearchCategoryResultType;
}

export default function SearchCategoryCard({
  isLoading,
  searchResult,
}: SearchCategoryCardProps) {
  const { t: translation } = useTranslation();
  return (
    <CustomCard
      helpId='help_4_7'
      title={
        !isLoading
          ? `${searchResult?.resultCount ?? 0} ${translation('searchResults')}`
          : undefined
      }
      ariaLiveForTitle={isLoading ? undefined : 'assertive'}>
      <div aria-busy={isLoading}>
        {isLoading && <Loader />}
        {!isLoading && searchResult && (
          <SearchCategoryResult items={searchResult?.items ?? []} />
        )}
      </div>
    </CustomCard>
  );
}
